import formattersPlugin from '../formattersPlugin';
import addMapAttributesOrigin from './addMapAttributesOrigin';
import addMapAttributesDestination from './addMapAttributesDestination';
import avoidExcludeAreaBoundingBox from './avoidAreaBoundingBox';
import avoidExcludeAreaPolygon from './avoidAreaPolygon';
import avoidExcludeAreaCorridor from './avoidAreaCorridor';
import avoidExcludeAreaRemove from './avoidAreaRemove';
import addChargingStatioinsBBox from './addChargingStatioinsBBox';
import regionDefitionAddPolygonPoint from './regionDefitionAddPolygonPoint';
import avoidAreaOnMapChange from './avoidAreaOnMapChange';
import time from './time';
import distance from './distance';
import actionsToManeuvers from './actionsToManeuvers';
import spansToManeuvers from './spansToManeuvers';
import olsMatrixRegionDefinitionBbox from './olsMatrixRegionDefinitionBbox';
import customizationSearchBbox from './customizationSearchBbox';

import olsMatrixRegionDefinitionCircle from './olsMatrixRegionDefinitionCircle';
import customizationSearchCircle from './customizationSearchCircle';
import customizationSearchAt from './customizationSearchAt';
import approachPathLocation from './approachPathLocation';
import olsVia from './olsVia';
import advancedLocations from './advancedLocations';
import taggedManeuvers from './taggedManeuvers';
import evMarkers from './evMarkers';
import dsMarkers from './dsMarkers';
import tollsMarkers from './tollsMarkers';
import customizationSearchMarkers from './customizationSearchMarkers';
import olsEvPolylines from './olsEvPolylines';
import hlsWaypoint from './hlsWaypoint';
import shapeToPositions from './shapeToPositions';
import flexPolyline from './flexPolyline';
import routeDecodingMarkers from './routeDecodingMarkers';
import searchAtMarkers from './searchAtMarkers';
import { setOrigin, setDestination } from './setIsoline';
import { addVia } from './addVia';
import tbtActionsToManeuvers from './tbtActionsToManeuvers';
import vectorTileUrl from './vectorTileUrl';
import mapAttributesSegments from './mapAttributesSegments';
import gpxTraceWaypoints from './gpxTraceWaypoints';

formattersPlugin.register('addMapAttributesOrigin', addMapAttributesOrigin);
formattersPlugin.register('addMapAttributesDestination', addMapAttributesDestination);
formattersPlugin.register('avoidExcludeAreaBbox', avoidExcludeAreaBoundingBox);
formattersPlugin.register('avoidExcludeAreaPolygon', avoidExcludeAreaPolygon);
formattersPlugin.register('avoidExcludeAreaCorridor', avoidExcludeAreaCorridor);
formattersPlugin.register('avoidExcludeAreaRemove', avoidExcludeAreaRemove);
formattersPlugin.register('addChargingStatioinsBBox', addChargingStatioinsBBox);

formattersPlugin.register(
  'regionDefitionAddPolygonPoint',
  regionDefitionAddPolygonPoint
);
formattersPlugin.register('avoidAreaOnMapChange', avoidAreaOnMapChange);
formattersPlugin.register('time', time);
formattersPlugin.register('distance', distance);
formattersPlugin.register('actionsToManeuvers', actionsToManeuvers);
formattersPlugin.register('spansToManeuvers', spansToManeuvers);
formattersPlugin.register(
  'olsMatrixRegionDefinitionBbox',
  olsMatrixRegionDefinitionBbox
);
formattersPlugin.register(
  'customizationSearchBbox',
  customizationSearchBbox
);
formattersPlugin.register(
  'olsMatrixRegionDefinitionCircle',
  olsMatrixRegionDefinitionCircle
);
formattersPlugin.register(
  'customizationSearchCircle',
  customizationSearchCircle
);
formattersPlugin.register(
  'customizationSearchAt',
  customizationSearchAt
);
formattersPlugin.register('approachPathLocation', approachPathLocation);
formattersPlugin.register('olsVia', olsVia);
formattersPlugin.register('advancedLocations', advancedLocations);
formattersPlugin.register('taggedManeuvers', taggedManeuvers);
formattersPlugin.register('olsEvPolylines', olsEvPolylines);
formattersPlugin.register('evMarkers', evMarkers);
formattersPlugin.register('dsMarkers', dsMarkers);
formattersPlugin.register('tollsMarkers', tollsMarkers);
formattersPlugin.register('customizationSearchMarkers', customizationSearchMarkers);
formattersPlugin.register('hlsWaypoints', hlsWaypoint);
formattersPlugin.register('shapeToPositions', shapeToPositions);
formattersPlugin.register('flexPolyline', flexPolyline);
formattersPlugin.register('routeDecodingMarkers', routeDecodingMarkers);
formattersPlugin.register('searchAtMarkers', searchAtMarkers);
formattersPlugin.register('setIsolineOrigin', setOrigin);
formattersPlugin.register('setIsolineDestination', setDestination);
formattersPlugin.register('addVia', addVia);
formattersPlugin.register('tbtActionsToManeuvers', tbtActionsToManeuvers);
formattersPlugin.register('vectorTileUrl', vectorTileUrl);
formattersPlugin.register('mapAttributesSegments', mapAttributesSegments);
formattersPlugin.register('gpxTraceWaypoints', gpxTraceWaypoints);

